import React from 'react';
import { accountTypes } from '../../utils/accountTypes';

import css from './TopbarCredits.module.css';

const TopbarCredits = ({ currentUser }) => {
  if (!currentUser) {
    return null;
  }

  const accountType = currentUser?.attributes?.profile?.protectedData?.accountType;
  const userCredits = currentUser?.attributes?.profile?.protectedData?.totalCredits || 0;

  // Only show credits for students (clients), not for mentors
  // Mentors don't use the credit system as they are the ones providing sessions
  if (accountType === accountTypes.mentor) {
    return null;
  }

  return (
    <span className={css.createListing}>
      Credits: <span className={css.credits}>{userCredits}</span>
    </span>
  );
};

export default TopbarCredits;
